import { Button } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
type ViewAllButtonProps = ComponentProps<typeof Button> & {
  theme?: 'light' | 'dark';
};
const ViewAllButton = ({
  theme = 'light',
  ...rest
}: ViewAllButtonProps) => {
  return <Button backgroundColor="transparent" border="1px solid" borderColor={theme === 'light' ? 'primary.500' : 'generic.0'} borderRadius="8px" color={theme === 'light' ? 'primary.500' : 'generic.0'} textStyle="paragraph.small" fontWeight="regular" height="48px" padding={4} width={{
    base: 'full',
    tablet: '332px'
  }} _hover={{
    backgroundColor: theme === 'light' ? 'primary.50' : 'neutral.700'
  }} _active={{
    backgroundColor: theme === 'light' ? 'primary.500 !important' : 'generic.0 !important',
    color: theme === 'light' ? 'generic.0 !important' : 'generic.100 !important',
    ...(theme === 'dark' && {
      borderColor: 'generic.0'
    })
  }} {...rest} data-sentry-element="Button" data-sentry-component="ViewAllButton" data-sentry-source-file="ViewAllButton.tsx">
      View all
    </Button>;
};
export default ViewAllButton;